import type {ConversationState} from './reducer.ts'
import type {V9Frame} from './v9-runtime.ts'
export function projectCommercialContext(state:ConversationState,fr?:V9Frame):boolean {
  const c=state.v9;
  return Boolean(c&&(c.projectMode==='only'||fr?.savedMain==='I02'||c.main==='I02'||c.frames.some(f=>f.card==='I02')))
}
export function projectAmount(value:string|undefined):number|null {
  if(!value?.trim())return null;
  const n=Number(value.replace(/[$,]/g,''));return Number.isFinite(n)&&n>=0?n:null
}
